<ng-template
  #itemMenu="rtConnectedOverlay"
  [open]="itemMenu.open"
  [origin]="overlayOrigin"
  (backdropClick)="itemMenu.open = false"
  [width]="180"
  hasBackdrop
  rt-connected-overlay
>
  <rt-dropdown>
    <rt-dropdown-item (click)="onDuplicate()">
      {{ 'tlc.ask_hr.forms.duplicate_form' | translate }}
    </rt-dropdown-item>
    <rt-dropdown-item (click)="onCopyLink()">
      {{ 'tlc.ask_hr.forms.copy_form_link' | translate }}
    </rt-dropdown-item>
    <rt-dropdown-item (click)="onDelete()">
      {{ 'tlc.ask_hr.forms.delete_form' | translate }}
    </rt-dropdown-item>
    <rt-dropdown-item (click)="onPreview()">
      {{ 'tlc.ask_hr.forms.preview' | translate }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>

<div class="header">
  @if (record.symbol; as symbol) {
    <rt-symbol [symbol]="symbol" margin-right-small-x />
  }
  <rt-heading variant="heading large" margin-right-auto>
    <span class="template-name">{{ record.name }}</span>
  </rt-heading>
  <div layout margin-left>
    <rt-icon-button variant="plain" iconName="edit" (click)="onEdit()" margin-right-small />
    <rt-icon-button
      #overlayOrigin="rtOverlayOrigin"
      rt-overlay-origin
      variant="plain"
      iconName="more-horiz"
      (click)="itemMenu.open = true"
    />
  </div>
</div>
<div class="description">
  <div
    prosemirrorBasicConfig
    [prosemirrorRender]="
      !record.descriptionJson || record.descriptionJson.doc
        ? record.descriptionJson
        : { doc: record.descriptionJson }
    "
    [prosemirrorRenderConfig]="ProsemirrorBasicConfig"
    class="description-content"
  ></div>
  <div layout layout-align-items-center layout-align-self-end>
    @if (!record.active) {
      <rt-offer-status-indicator
        [offerStatus]="{ status: 'draft', kind: 'job' }"
        margin-right-small-x
      />
      <span text-weight-semi-bold margin-right-small-x>
        {{ 'tlc.ask_hr.forms.submissions_disabled' | translate }}
      </span>
    }
    <rt-admins-avatars [admins]="assignedUsers()" [stacked]="true" />
  </div>
</div>
